<template>
    <!-- theame one -->
    <div v-if="themeStore.themeIndex === 1">
        <CheckinRewardsOne ref="checkinRef" :data-set="dataSet" @update-info="updateInfo"
            @callCheckinClaim="callCheckinClaim" @goToVerifyPhoneNum="goToVerifyPhoneNum" />
    </div>

    <!-- theame Two -->
    <div v-if="themeStore.themeIndex === 2">
        <CheckinRewardsTwo ref="checkinRef" :data-set="dataSet" @update-info="updateInfo"
            @callCheckinClaim="callCheckinClaim" @goToVerifyPhoneNum="goToVerifyPhoneNum" />
    </div>
    <!-- theame Three -->
    <div v-if="themeStore.themeIndex === 3">
        <checkinRewardsThree ref="checkinRef" :data-set="dataSet" @update-info="updateInfo"
            @callCheckinClaim="callCheckinClaim" @goToVerifyPhoneNum="goToVerifyPhoneNum" />
    </div>

    <StatusPopup ref="statusRef" :is-show-success="isSuccess" :content="toastContent" />
    <LoadingScreen ref="loadingRef" />

</template>
<script setup lang="ts">
import { getActivityInformations } from '@/api/common';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import { computed, onMounted, ref } from 'vue';
import { checkinRewardClaim } from '@/api/activity';
import CheckinRewardsOne from '@/themes/themeOne/checkinRewards/checkinRewards.vue';
import CheckinRewardsTwo from '@/themes/themeTwo/checkinRewards/checkinRewards.vue';
import checkinRewardsThree from '@/themes/themeThree/checkinRewards/checkinRewards.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { CheckingRewardData } from './checkinRewards';
import { useThemeStore } from '@/stores/theme';

const themeStore = useThemeStore()
const isSuccess = ref(false)
const statusRef = ref()
const loadingRef = ref()
const toastContent = ref('')
const activityInfo = ref([])
const checkinRef = ref()

const isPhoneVerified = ref(false)
const notVerifyConfig = ref<any>({})
const verifyConfig = ref<any>({})
const popverifyType = ref(0)
const bannerIcon = ref('')
const isShowPhoneVerification = ref(false)
const hasNotVerifyData = ref(false)
const hasVerifyPhoneData = ref(false)

const dataSet = computed<CheckingRewardData>(() => ({
    isPhoneVerified: isPhoneVerified.value,
    notVerifyConfig: notVerifyConfig.value,
    verifyConfig: verifyConfig.value,
    popverifyType: popverifyType.value,
    bannerIcon: bannerIcon.value,
    isShowPhoneVerification: isShowPhoneVerification.value,
    hasNotVerifyData: hasNotVerifyData.value,
    hasVerifyPhoneData: hasVerifyPhoneData.value,
    activityInfo: activityInfo.value
}))

const showError = (message: string) => {
    toastContent.value = message;
    isSuccess.value = false;
    statusRef.value.open()
}
const getActivityInfo = () => {
    loadingRef.value.open()
    let data = {
        activityId: "signin_rewards",
    }
    getActivityInformations(data).then(res => {
        loadingRef.value.close()
        bannerIcon.value = res.data?.floatIcon
        activityInfo.value = JSON.parse(res.data?.activityIntro);
        notVerifyConfig.value = res.data?.config?.not_verify_config || {}
        verifyConfig.value = res.data?.config?.phone_verify_config || {}
        isPhoneVerified.value = res.data?.isPhoneVerified === 1 ? true : false
        isShowPhoneVerification.value = (res.data?.config?.is_sms_verify === 1 || res.data?.config?.is_whatsapp_verify === 1) ? true : false

        if (notVerifyConfig.value?.days == 0 && notVerifyConfig.value?.reward == 0) {
            hasNotVerifyData.value = false
        } else {
            hasNotVerifyData.value = true
        }

        if (verifyConfig.value?.days == 0 && verifyConfig.value?.reward == 0) {
            hasVerifyPhoneData.value = false
        } else {
            hasVerifyPhoneData.value = true
        }

        if (popverifyType.value === 1) {
            checkinRef.value.checkinclose()
            setTimeout(() => {
                callCheckinClaim(verifyConfig.value, 2)
            }, 100)
        }
        if (isPhoneVerified.value) {
            callCheckinClaim(verifyConfig.value, 2)
        } else {
            callCheckinClaim(notVerifyConfig.value, 1)
        }

    }).catch(err => {
        if (err.code != 401) {
            loadingRef.value.close();
            showError(err);
        }
    })
}

const callCheckinClaim = (configData: any, claimType: number) => {
    if (claimType == 1 && isPhoneVerified.value) {
        console.log('');
    } else {
        loadingRef.value.open()
        let data = {
            type: claimType,
        }
        checkinRewardClaim(data).then(res => {
            loadingRef.value.close()
            openCheckinPopup(configData, claimType)
        }).catch(err => {
            loadingRef.value.close()
            showError(err);
        })
    }
}

const openCheckinPopup = (data: any, type: number) => {
    if (type === 2) {
        checkinRef.value.checkinOpen(data, isPhoneVerified.value)
    } else if (type === 1) {
        if (!isPhoneVerified.value) {
            checkinRef.value.checkinOpen(data, isPhoneVerified.value)
        }
    }
}
const goToVerifyPhoneNum = (type: any) => {
    checkinRef.value.openVerifyPhonePopup()
    if (type == 1) {
        popverifyType.value = 1
    }
}
const updateInfo = () => {
    getActivityInfo()
}
onMounted(() => {
    getActivityInfo()
})
</script>
<style scoped>
.bannerContainer img {
    width: 100%;
}

.bannerContainer {
    padding-top: 50px;
}

.checkin_container {
    padding: 30px 15px;
}

.claimField img {
    width: 15px;
    padding-right: 5px;
}

.claimText {
    color: #fff;
    display: flex;
    justify-content: left;
    flex-direction: column;
    margin-bottom: 20px;
}

.text {
    padding: 2.5px;
    font-size: 12px;
}

.text span {
    color: #e61a1a;
    padding: 0 5px;
}

.claimColumn {
    display: flex;
    justify-content: center;
    align-items: center;
}

.click_btn {
    color: #12151A;
    font-size: 11.5px;
    background-image: linear-gradient(rgb(248, 216, 167) 0%, rgb(240, 168, 83) 100%);
    border-radius: 5px;
    padding: 10px;
    display: flex;
    align-items: center;
    display: flex;
    text-align: center;
    justify-content: center;
    width: 40%;
}

.disableBtn {
    background-image: linear-gradient(rgb(248 216 167 / 18%) 0%, rgb(240 168 83 / 14%) 100%);
    color: #717171ad;
    font-weight: bold;
}

.bottom_text {
    padding: 25px 0;
}

.line1 {
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.line2 {
    transform: scaleX(-1);
    background-image: linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, rgba(255, 255, 255, 0.65) 100%);
    border-radius: 1px;
    height: 2px;
    margin: 8px 0 0 0;
}

.title {
    color: rgba(255, 255, 255, 0.85);
    font-size: 15px;
    display: flex;
    justify-content: center;
}

.line_text {
    color: rgba(255, 255, 255, 0.45);
    font-size: 14px;
    padding: 10px;
}
</style>